import guard from '../../components/unsaved/guard'

import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import DisplayHeader from 'scoreboard/components/display-header'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import FormView from 'scoreboard/components/form-view'
import FormDirector from './form-director'
import guardConstants from 'scoreboard/components/unsaved/guard-constants'
import i18n from 'scoreboard/components/i18n'
import DatasetNotReady from 'scoreboard/datasets/not-available/dataset-not-ready'
import wrapModel from 'scoreboard/components/wrap-model'
import Dataset from 'scoreboard/datasets/model/dataset'
import SendToOptions from 'scoreboard/components/send-to-options'
import FormType from 'scoreboard/forms/model/form-type'
const { FORM } = FormType
import conductor from 'scoreboard/components/conductor'
import navigationTab from './navigation-tab.hbs'
import FormActionType from 'scoreboard/forms/model/form-action-type'
const { GO_TO_PAGE } = FormActionType
import { isV5, isV6 } from 'scoreboard/components/version'
import template from './forms-overview.hbs'

const FormsOverview = Backbone.View.extend({

	tagName: 'form',

	className: 'forms forms-overview display-layout table-hack',

	events: {
		'click .navigation-tab a': 'onClickNavigationTab'
	},

	initialize: function(options = {}) {
		this.options = options
		this.embeddedToken = this.options.embeddedToken

		this.header = new DisplayHeader({
			model: this.model,
			subsection: 'overview',
			tabs: this.getTabs(),
			sendToOptions: SendToOptions.sharedForm({
				section: 'forms'
			})
		})

		const MyFormView = FormView.extend({
			// Our "Form" isn't a traditional form, so we don't submit it in the
			// same way we do elsewhere in the app. There can be multiple
			// buttons to save/submit the form, and we don't always know what
			// they do until they are clicked and a request is sent to the
			// server
			submit: function(e) { e.stopPropagation(); e.preventDefault() }
		})
		this.formView = new MyFormView({
			el: this.el,
			allowCleanSubmission: true,
			guardOptions: {
				messages: {
					prompt: i18n.get('forms.guard.prompt'),
					save: i18n.get('forms.guard.save')
				},
				hideCancel: true,
				keepChangesFn: () => guardConstants.HIDE_WARNING
			},
			// There are no buttons to submit on the overall page/overview so
			// we'll prevent trying to set them up which can conflict with
			// form button widgets.
			preventButtonSetup: true
		})
	},

	render: function() {
		this.$el.empty().append(this.header.el, template())

		const dataset = wrapModel(this.model.get('dataset'), Dataset)
		if (dataset.isComplete()) {
			this.renderFormDirector()
		} else {
			// #35724 if the dataset is building, then display the building animation
			const notReadyView = new DatasetNotReady({
				model: dataset,
				noHeader: true,
				useLinkedDatasetProgress: false
			}).on('ready', ({status}) => {
				const dataset = this.model.get('dataset')
				dataset.status = status
				this.model.set('dataset', dataset)
				this.render()
			})
			this.$('.display-pane-body').append(notReadyView.el)
			notReadyView.render()
			// fix the positioning of the dataset building animation
			this.$('.table-hack-cell').removeClass('table-hack-cell')
		}
		// must be after this.renderFormDirector
		this.renderHeader()
		// #55488 when bookmarked, need to render the tabs again because the
		// display header doesn't like tabs that it doesn't know about
		this.renderTabs()

		if (this.embeddedToken) {
			// Remove buttons
			this.$('.sp-navigate, .display-header-buttons').remove()
		}
		this.formView.start()

		// If there's no starting page, say so in a banner-error
		if (this.model.get('type') === FORM &&
			_.isNil(this.model.get('startingFormId'))) {
			this.formView.errorHtml(i18n.get('forms.errors.noStartingPage'))
		}
		this.listenTo(this.formDirector, 'go-to-page', submitting => {
			this.$el.toggleClass('is-submitting-form', submitting)
		})
		this.setWidgetListGrid()
		this.on('resize', () => this.setWidgetListGrid())

		return this
	},

	/**
	 * Retrieves the tabs to show in the header. Handles displaying navigation
	 * tabs if they should be visible
	 * @return {String} the HTML for the tabs
	 */
	getTabs: function() {
		let tabHtml = tabs({
			id: this.model.id,
			section: 'forms',
			overviewTabCode: 'common.view',
			hideInfo: true,
			hideAlerts: true
		})
		if (_.isEmpty(this.model.get('navigationPages'))) {
			return tabHtml
		} else {
			let tabsEl = $(tabHtml)
			tabsEl.find('.overview-tab').remove()
			_.eachRight(this.model.get('navigationPages'), page => {
				let current = page.id == this.getCurrentTabId()
				let args = _.extend({ current }, page)
				if (isV5()) {
					tabsEl.prepend(navigationTab(args))
				}
				if (isV6()) {
					tabsEl.find('.left-tabs').prepend(navigationTab(args))
				}
			})
			return tabsEl.prop('outerHTML')
		}
	},

	getCurrentTabId: function() {
		return this.model.get('type') == FORM ?
			this.model.get('startingFormId') : this.model.id
	},

	renderHeader: function() {
		this.header.render()
		this.highlightCurrentTab()
		this.changeEditTabUrl()
	},

	/** Highlights the appropriate tab in the header */
	highlightCurrentTab: function() {
		this.$('.navigation-tab a').removeClass('current')
		this.$(`.navigation-tab a[data-page-id="${this.getCurrentTabId()}"]`)
			.addClass('current')
	},

	/** Re-renders the tabs in the header */
	renderTabs: function() {
		let tabHtml = this.getTabs()
		this.$('.tabs').replaceWith(tabHtml)

		// if the View tab is visible, it should be highlighted
		this.$('.overview-tab a').addClass('current')

		let hasNavigationTabs = !_.isEmpty(this.model.get('navigationPages'))
		this.$el.toggleClass('has-navigation-tabs', hasNavigationTabs)

		this.header._updateSpectatedEditTab()

		// #59077
		// Make sure we secure permissions after any tab render so the edit tab
		// does not show up when it shouldn't
		this.secureTabs()
	},

	/**
	 * Changes the edit tab URL to point to the appropriate location. If we're
	 * viewing a form page, we should go to the page instead of to the
	 * form itself. If someone wants to rename the form, they can click on the
	 * form in the nav pane.
	 */
	changeEditTabUrl: function(goToPageFormId) {
		const {id, startingFormId} = this.model.attributes
		let formOrPageId
		if (conductor.section() == 'bookmarks') {
			// If viewing a form in bookmarks, edit page ID should be the the ID of
			// the bookmark.
			formOrPageId = conductor.id()
		} else {
			// #36580 go to the page being viewed or starting page
			// #35096 otherwise, edit the entire form
			formOrPageId = goToPageFormId || startingFormId || id
		}
		// #36579 So any conductor overview/edit urls go to the right page
		this.domainObjectId = formOrPageId // see appDisplay.domainObjectId()

		let url = `forms/${formOrPageId}/edit`
		this.$('.edit-tab .sp-navigate')
			.attr('href', url)
	},

	renderFormDirector: function() {
		if (!this.formDirector) {
			this.formDirector = new FormDirector({
				model: this.model,
				formView: this.formView,
				embeddedToken: this.embeddedToken
			})
			this.formDirector.on('acted', action => {
				if (action.type == GO_TO_PAGE) {
					const {goToPageFormId} = action
					this.changeEditTabUrl(goToPageFormId)
					this.renderTabs()
				}
				this.setWidgetListGrid()
			})
		}
		this.toggleFormDirectorContainer()
		this.formDirector.render({ initialRender: true })
	},

	/**
	 * Shows the form director container if the form has widgets, hides it
	 * otherwise
	 */
	toggleFormDirectorContainer() {
		let hasNoWidgets = _.isEmpty(this.formDirector.model.widgetsById)
		this.$('.form-director-container')
			.toggleClass('is-not-displayed', hasNoWidgets)
			.append(this.formDirector.el)
	},

	/**
	 * If there is a record-list-widget present, make it fill any extra space
	 * on screen if there is space available. If there is no empty space,
	 * it has a min-height set.
	 */
	setWidgetListGrid: function() {
		if (this.$('.record-list-widget').length) {
			let widgetsView = this.$('.widgets-view')

			if (!this.gridSetup) {
				let widgets = widgetsView.children()
				let gridTemplateRows = ''

				widgets.each((i, widget) => {
					let widgetEl = $(widget)
					if (widgetEl.hasClass('record-list-widget')) {
						// Take up all available space
						gridTemplateRows += '1fr '
					} else {
						// Only take up space needed
						gridTemplateRows += 'auto '
						// If the widgets haven't fully been added to the DOM
						// yet, recalculate the heights once they are.
						widgetEl.on('ready', () => {
							this.setWidgetListGrid()
						})
					}
				})

				widgetsView.css('grid-template-rows', gridTemplateRows)

				// We don't need to go through and set the grid up again
				// because it won't change in the overview.
				this.gridSetup = true
			}

			let container = this.$('.form-director-container')
			let containerIsOverflowing =
				container[0].scrollHeight > container[0].clientHeight
			container.toggleClass('is-overflowing', containerIsOverflowing)
		}
	},

	onClickNavigationTab: function(e) {
		guard.conditionallyRun(async () => {
			let goToPageFormId = $(e.target).attr('data-page-id')
			let action = {
				type: GO_TO_PAGE,
				goToPageFormId
			}

			// #61241 show/hide tabs on the 'directed' event instead of the
			// promise returned by formDirector.direct(), so that the visibility
			// has been taken care of before widgets start rendering
			this.listenToOnce(this.formDirector, 'directed', () => {
				this.$el.removeClass('is-not-displayed')
				this.renderTabs()

				// #58453
				// Switching tabs may mean going from a page with no widgets to
				// one with widgets (or vice versa). Handle this by toggling
				// the form director container's visibility based on this state.
				this.toggleFormDirectorContainer()
			})

			await this.formDirector.direct([action], { hasGoToPage: true })
		})
	},

	/**
	 * Ensures that the tabs are secure based on the current user's permissions
	 */
	secureTabs: function() {
		this.header.conditionallyHideEditTab(this.model.isEditable())
	},

	remove: function() {
		Backbone.View.prototype.render.apply(this, this.arguments)
		_.invokeMap([this.formDirector, this.loadingDots], 'remove')
	}
})

export default FormsOverview
FormsOverview.__filename__ = 'forms/overview/forms-overview.js'
